import { useContext } from "react";
import LoadingContext from "../context/Loading";

const useLoading = () => {
  const { setIsLoading } = useContext(LoadingContext);

  return {
    show: () => setIsLoading(true),
    hide: () => setIsLoading(false),
    set: (value: boolean) => setIsLoading(value),
  };
};

export default useLoading;
